import {
  Box,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import { closeShowTeacherAdminDataModel } from "../../../../modules/admin-modules/models/Actions";

const ShowTeacherAdminData = ({ data }) => {
  const openTeacherAdminData = useSelector((state) => state.model.isOpen39);
  const dispatch = useDispatch();
  
  
  if (!data) {
    return null;
  }
  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        بيانات المعلم الإداري
      </Heading>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeShowTeacherAdminDataModel());
  };
  return (
    <MainModel header={header} closeFunc={closeFunc} openVar={openTeacherAdminData}>
      <TableContainer>
        <Table variant="striped" dir="rtl">
          <Tbody>
            <Tr>
              <Td>اسم المعلم الإداري</Td>
              <Td>{data?.data?.name || data?.name || 'غير محدد'}</Td>
            </Tr>
            <Tr>
              <Td>رقم الهاتف</Td>
              <Td>{data?.data?.phone || data?.phone || 'غير محدد'}</Td>
            </Tr>
            <Tr>
              <Td>كلمة المرور</Td>
              <Td>{data?.data?.unhashed_password || data?.unhashed_password || 'غير محدد'}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </MainModel>
  );
};

export default ShowTeacherAdminData;
